import { ADD_NEW_BOOK, DELETE_BOOKS, SELECT_FOR_UPDATE, SET_BOOKS, UPDATE_BOOK } from "./actionType"

export const addBook = (data) => {
    return {
        type: ADD_NEW_BOOK,
        payload: data
    }
}
export const setBooks = (data) => {
    return {
        type: SET_BOOKS,
        payload: data
    }
}
export const updateBook = (data) => {
    return {
        type: UPDATE_BOOK,
        payload: data,
    }
}
export const selectForUpdate = (data) => {
    return {
        type: SELECT_FOR_UPDATE,
        payload: data,
    }
}
export const deleteBook = (id) => {
    return {
        type: DELETE_BOOKS,
        payload: id,
    }
} 